class FJFake3dExportConfig {
    constructor() {
        this._exportResolution = {};
    }

    setExportResolution(type, value) {
        this._exportResolution[type] = value;
    }
    getExportResolution(type) {
        return this._exportResolution[type];
    }
}

const config = new FJFake3dExportConfig();
export default config;
